
<div class="mobile_step-title d-md-none" tabindex="0" #focus1 autofocus>
    <span>{{currentRoute}}</span> 
    <!-- <span role="presentation" [attr.aria-label]="ariaText" >{{routeNo}} of 6 </span> -->
    <label   [attr.aria-label]="ariaText" role="link">  {{routeNo}} of 6 </label>
    <!-- <span  class="visually-hidden" [attr.aria-label]="ariaText"></span> -->
</div>